export const STRYD_TWITTER_HANDLE = '@strydrunning';
export const STRYD_FACEBOOK_COMMUNITY_HREF =
  'https://www.facebook.com/groups/strydcommunity/';
export const STRYD_TWITTER_HREF = 'https://twitter.com/strydrunning';
export const STRYD_INTSTAGRAM_HREF = 'https://www.instagram.com/strydrunning';
export const STRYD_YOUTUBE_HREF =
  'https://www.youtube.com/channel/UCLcAyUN3rDsagHbPA0z1C3g';
